//
// Copyright (c) 2011-2026 by Curalate, Inc.
//

import { keepPreviousData, queryOptions } from '@tanstack/react-query';

import { getContentLibraryAutocompleteV2 } from '@apis/content-library/contentLibraryApi';
import { ContentLibraryFilter } from '@apis/content-library/contentLibraryApiModel';
import {
  MediaLibrarySearchTagHeaders,
  MediaLibrarySearchTagPrefixes,
} from '@components/media-filters/mediaFilterConstants';
import { QueryKeyConstants } from '@queries/QueryKeyConstants';
import { FIVE_MINUTES_STALE_TIME } from '@queries/QueryOptionsConstants';

export interface AutocompleteUsernamesHashtagsV2Params {
  prefix: string;
  query: ContentLibraryFilter;
}

export const getAutocompleteUsernamesHashtagsV2QueryOptions = ({
  prefix,
  query,
}: AutocompleteUsernamesHashtagsV2Params) =>
  queryOptions({
    queryKey: [
      QueryKeyConstants.MediaFilters,
      QueryKeyConstants.MediaFiltersAutocompleteUsernamesHashtags,
      { prefix, query },
    ],
    queryFn: ({ signal }) =>
      getContentLibraryAutocompleteV2(
        { autocompleteType: 'InstagramUsersAndHashtags', prefix, query },
        { signal },
      ),
    select: ({ hashtags, usernames }) => ({
      hashtags: hashtags.map(({ count, value }) => ({
        count,
        header: MediaLibrarySearchTagHeaders.igHashtags,
        label: value,
        prefix: MediaLibrarySearchTagPrefixes.igHashtags,
      })),
      usernames: usernames.map(({ count, value }) => ({
        count,
        header: MediaLibrarySearchTagHeaders.igUsernames,
        label: value,
        prefix: MediaLibrarySearchTagPrefixes.igUsernames,
      })),
    }),
    staleTime: FIVE_MINUTES_STALE_TIME,
    placeholderData: keepPreviousData,
  });
